import TermsConditionLUX from './lux-modals-for-login';

import { createContainer } from '@dbk-legacy/muster/react';

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    loginTerms: {
      pdfLinkData: true,
      onGetPdf: { $call: 'getPdfLink' },
    },
  },
})(TermsConditionLUX);